import React from 'react';

/**
 * Highlights matching text within a string
 * @param {string} text - The text to search within
 * @param {string} highlight - The text to highlight
 * @returns {React.ReactNode} Text with highlighted portions wrapped in spans
 */
export const highlightText = (text, highlight) => {
  if (!highlight || !text) return text;
  const parts = text.split(new RegExp(`(${highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'));
  return parts.map((part, i) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <span key={i} className="ui-select-highlight">
        {part}
      </span>
    ) : (
      part
    )
  );
};

/**
 * Creates a tag object
 * @param {string} text - Tag display text
 * @param {string|null} id - Tag identifier
 * @param {string|null} className - CSS class name
 * @param {boolean} invalid - Whether the tag is invalid
 * @returns {Object} Tag object
 */
export const createTag = (text, id, className, invalid) => ({
  text: text || null,
  id: id || null,
  class: className || null,
  invalid: invalid !== undefined ? invalid : !id,
});
